import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

import IconItem from '@/ui/components/IconItem';
import { Props } from '@/ui/components/IconItem/types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const UnknownIconItem = (props: Props) => {
  const updatedProps = {
    ...props,
    icon: props.icon || faQuestionCircle,
    color: props.color || 'text-yellow-500',
    children: <span className="italic">{props.children}</span>
  };

  return <IconItem {...updatedProps} />;
};

export default UnknownIconItem;
